import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import purchaseNowRequest from './purchaseNow.repository';

type InitialState = {
  loading: boolean;
  data?: boolean;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const purchaseNow = createAsyncThunk(
  'purchaseNow',
  async (tempId: string) => {
    await purchaseNowRequest(tempId);
    return true;
  }
);

const purchaseNowSlice = createSlice({
  name: 'purchaseNow',
  initialState,
  reducers: {
    purchaseNowReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(purchaseNow.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      purchaseNow.fulfilled,
      (state, action: PayloadAction<boolean>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(purchaseNow.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default purchaseNowSlice.reducer;
export const { purchaseNowReset } = purchaseNowSlice.actions;
